
import { type FC } from 'react';

import { type LString, t, T, TM } from '@web-solutions/module-localization';
import { Title } from '@web-solutions/core/ui-elements';
import type { ImageSource } from '@web-solutions/core/interfaces/images';

import { SpecialOfferBase } from '../special-offer-base'
import { tKey } from '../constants';
import type { SpectialOfferTypeProps } from '../types'

import styles from './style.module.scss';

interface SpecialOfferInfoProps extends SpectialOfferTypeProps {
  offerText?: LString,
  image?: ImageSource
}

export const SpecialOfferInfo: FC<SpecialOfferInfoProps> = ({
  isOpen,
  offerText,
  image,
  onGetClick,
  onClose,
}) => (
  <SpecialOfferBase
    mode='info'
    isCloseOnSubmit
    isOpen={isOpen}
    withCloseButton={false}
    className={styles.modalContainer}
    onClose={onClose}
    onGetClick={onGetClick}
  >
    <Title className={styles.title}>
      {t(`${tKey}.info.title`)}
    </Title>
    <p className={styles.subtitle}>
      <T k={`${tKey}.info.subtitle`} />
    </p>
    {image &&
      <img
        className={styles.graphicImage}
        width='325'
        height='188'
        src={image?.src}
        srcSet={image?.srcSet}
        alt='graphic'
      />
    }
    <p className={styles.graphicDescription}>
      <T k={`${tKey}.info.graphic_description`} />
    </p>
    <div className={styles.offerWrapper}>
      <p className={styles.offerText}>
        <TM k={offerText} defaultKey={`${tKey}.info.offer`} />
      </p>
    </div>
  </SpecialOfferBase >
);